<template>
  <footer class="app-footer">
    <div class="container">
      <div class="row justify-content-center my-3 my-md-4">
        <div class="col-5 col-sm-4 col-md-3 col-lg-2">
          <img class="img-responsive w-100" src="/images/logo_text.svg">
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <p class="text-center">{{ appName }} {{ new Date().getFullYear() }} &copy;</p>
        </div>
      </div>
    </div>
    <back-to-top bottom="15px" right="15px" visibleoffset="500">
      <b-btn class="btn-to-top" variant="primary">
        <i class="fa fa-angle-up"></i>
      </b-btn>
    </back-to-top>
    <b-modal id="login" title="無料登録・ログイン" lazy hide-footer centered size="lg">
      <b-tabs pills lazy content-class="border-0 mt-3">
        <b-tab title="無料登録" lazy active class="p-0">
          <register @success="$root.$emit('bv::hide::modal', 'login', null)"/>
        </b-tab>
        <b-tab title="ログイン" lazy class="p-0">
          <login @success="$root.$emit('bv::hide::modal', 'login', null)"/>
        </b-tab>
      </b-tabs>
      <div class="text-right">
        <b-btn variant="link" @click="$root.$emit('bv::hide::modal', 'login', null)">
          ログインせずに続く
        </b-btn>
      </div>
    </b-modal>
  </footer>
</template>
<script>
import Login from '~/components/Login'
import Register from '~/components/Register'
import BackToTop from 'vue-backtotop'

export default {
  name: 'c-footer',

  components: {
    Login,
    Register,
    BackToTop
  },

  data: () => ({
    appName: window.config.appName
  }),
}

</script>



// WEBPACK FOOTER //
// resources/js/components/Footer.vue